import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isFilterActive: false,
        activeIndex: 1,
        isMainActive: false,
        templates: []
    },
    getters: {
        filterActive: state => {
            return state.isFilterActive
        },
        getActiveMenu: state => {
            return state.activeIndex
        },
        getMainActive: state => {
            return state.isMainActive
        },
        getActiveTemplateFilter: state => {
            return state.templates
        }
    },
    mutations: {
        setFilterActive(state, isActive) {
            state.isFilterActive = isActive
        },
        setActiveIndex(state, index){
            state.activeIndex = index;
        },
        setMainMenuActive(state, isActive) {
            state.isMainActive = isActive
        },
        setActiveTemplateFilter(state, templates){
            console.log("templates", templates)
            state.templates = [...templates]
        }
    }
})